import { Injectable, signal } from '@angular/core';

export type ParentTriggerType = 'save' | 'cancel' | 'requestVariationData'  | 'requestStockData' | 
  'requestGeneralData' | 'tabActivated' | '';
export type ChildReceiverType = 'general' | 'channels' | 'inventory' | 'details-tab' | 'variations' | 'stock' | 'printers' | 'all' | '';
export interface ParentTriggerInterface {
  trigger: ParentTriggerType;
  sender?: ChildReceiverType;
  child: ChildReceiverType;
  params?: any;
}

export type NotificationType = 'operationOutcome' | 'variationData'  | 'stockData' | 'generalData' | 'stockCost' | '';
export interface ParentNotificationInterface {
  notification: NotificationType;
  child: ChildReceiverType;
  params?: any;
}

export interface ChildNotificationInterface {
  notification: NotificationType;
  receiver?: ChildReceiverType;
  params?: any;
}

@Injectable()
export class ItemCommunicationService {

  // --- Parent-to-child communication ---
  private _parentTrigger = signal<ParentTriggerInterface>({trigger: '', child: ''});
  readonly parentTrigger = this._parentTrigger.asReadonly();

  private setParentTrigger(trigger: ParentTriggerInterface) {
    this._parentTrigger.set(trigger);
  }

  private _parentNotifier = signal<ParentNotificationInterface>({notification: '', child: ''});
  readonly parentNotifier = this._parentNotifier.asReadonly();

  private setParentNotifier(notification: ParentNotificationInterface) {
    this._parentNotifier.set(notification);
  }
  // ---


  // --- Child-to-parent communication ---
  private _childNotifier = signal<ChildNotificationInterface>({notification: ''});
  readonly childNotifier = this._childNotifier.asReadonly();

  notifyParent(notification: ChildNotificationInterface) {
    this._childNotifier.set(notification);
    if(notification.receiver) {
      this.createParentNotification();
    }
  }

  resetChildNotifier() {
    this._childNotifier.set({notification: ''});
  }
  // ---


  // Metodi pubblici per gestire la comunicazione parent-child

  createParentTrigger(trigger: ParentTriggerType, receiver: ChildReceiverType, sender?: ChildReceiverType, params?: any) {
    if(trigger && receiver) {
      this.setParentTrigger({
        trigger: trigger,
        child: receiver,
        sender: sender,
        params: params
      })
    }
  }
    
  createParentNotification() {
    if(this._childNotifier()?.notification) {
      this.setParentNotifier({
        notification: this._childNotifier()?.notification,
        child: this._childNotifier()?.receiver!,
        params: this._childNotifier()?.params
      })
    }
    this.resetChildNotifier();
  }

}
